<template>
  <div>
    <div>
      <b-row align-v="center" align-h="between">
        <b-col align-self="center"
          ><b-form-input
            v-model="search.cellphone"
            placeholder="جستجو کاربر بر اساس شماره موبایل"
            class="mb-3"
            maxlength="11"
            @keydown.enter="updateUsers"
          ></b-form-input>
        </b-col>
        <b-col align-v="center" align-h="between">
          <button
            type="button"
            class="btn btn-primary mb-3"
            title="جستجو"
            @click="updateUsers"
          >
            <i class="fal fa-search pt-1" />
            جستجو
          </button>
        </b-col>
        <b-col>
          <div class="d-flex justify-content-end">
            <div class="alert d-flex align-items-right bg-primary">
              <span class="text-white font-size-sm font-weight-bold m-0">
                تعداد کاربران:

                {{ numberFormat(adminUsersPagination.total) }}
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <div>
      <div v-if="loaded && adminUsers.length === 0">
        <div class="alert alert-primary" role="alert">کاربری یافت نشد.</div>
      </div>
    </div>
    <div v-if="loaded && adminUsers.length" class="card card-custom gutter-b">
      <div class="card-body">
        <!-- {{adminUsers}} -->
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>نام</th>
                <th>تلفن</th>
                <th>
                  تاریخ ثبت ‌نام
                  <span
                    @click="sortBy('created_at')"
                    v-html="sortIcon('created_at')"
                  ></span>
                </th>
                <th>عملیات ها</th>
              </tr>
            </thead>
            <tbody>
              <!-- <pre>{{adminUsers}}</pre> -->
              <tr v-for="user in adminUsers" :key="user.id">
                <!-- <td>{{ user.first_name || "_" }}</td> -->
                <td>{{ gFullName(user) || "_" }}</td>
                <td dir="ltr">
                  <a :href="`tel:${user.cellphone}`">
                    {{ prettyPhone(user.cellphone) }}
                  </a>
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(user.created_at) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'admin-users-show',
                      params: { id: user.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                  <router-link
                    :to="{
                      name: 'admin-users-edit',
                      params: { id: user.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-edit"></i>
                    ویرایش
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="adminUsersPagination.lastPage > 1">
      <b-pagination
        v-model="adminUsersPagination.currentPage"
        :total-rows="adminUsersPagination.total"
        :per-page="adminUsersPagination.perPage"
        aria-controls="my-table"
        @input="updateUsers()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_ADMIN_USERS,
  DESTROY_ADMIN_USER,
  SET_ADMIN_USERS_PAGINATION_PAGE
} from "@/core/services/store/admin/users.module.js";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "adminUsers",
  data() {
    return {
      loaded: false,
      searchUser: "",
      search: {
        cellphone: "",
        company: null
      }
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      },
      { title: "کاربران" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "admin-users-create" },
          class: "btn-primary"
        }
      ]
    });

    this.updateUsers();
  },
  computed: {
    ...mapGetters(["adminUsers", "adminUsersPagination"])
  },
  methods: {
    sortIcon(field) {
      let col = this.$store.state.adminUsers.sort.col;
      let dir = this.$store.state.adminUsers.sort.dir;

      if (col !== field) {
        return '<i class="fal fa-sort cursor-pointer"></i>';
      }
      if (dir === "asc") {
        return '<i class="fal fa-sort-up cursor-pointer"></i>';
      }
      return '<i class="fal fa-sort-down cursor-pointer"></i>';
    },
    sortBy(field) {
      this.$store.commit(SET_ADMIN_USERS_PAGINATION_PAGE, 1);

      this.updateUsers({
        col: field,
        dir: this.$store.state.adminUsers.sort.dir === "desc" ? "asc" : "desc"
      });
    },
    updateUsers(sort = {}) {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_USERS, {
          sort: sort,
          cellphone: this.search.cellphone,
          company: this.search.company
        })
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف کاربر اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_ADMIN_USER, id).then(() => {
            this.updateUsers();
          });
        }
      });
    },
    balance(user) {
      if (user.wallets && user.wallets[0]) {
        return this.numberFormat(parseInt(user.wallets[0].balance / 10));
      }
      return "-";
    }
  }
};
</script>
